<div class="gw-space-y-6 gw-p-x-large gw-max-w-lg">
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <p class="gw-text-text-primary gw-text-base">
      {{
        'features.settings.parameters.gateweeCollectionConfig.description'
          | translate
      }}
    </p>
    <div [formGroup]="bankingForm" class="gw-space-y-4">
      <gatewee-input-v2
        [form]="bankingForm"
        controlName="pixKey"
        [label]="
          'features.settings.parameters.gateweeCollectionConfig.pixKey.label'
            | translate
        "
        id="gcc-pixKey"
        type="text"
      ></gatewee-input-v2>
      <gatewee-select-v3
        [items]="pixKeyTypeItems"
        formControlName="pixKeyType"
        [label]="
          'features.settings.parameters.gateweeCollectionConfig.pixKeyType.label'
            | translate
        "
        inputId="gcc-pixKeyType"
        [required]="true"
      ></gatewee-select-v3>
      <gatewee-input-v2
        [form]="bankingForm"
        controlName="name"
        [label]="
          'features.settings.parameters.gateweeCollectionConfig.holderName.label'
            | translate
        "
        id="gcc-name"
        type="text"
      ></gatewee-input-v2>
      <gatewee-input-v2
        [form]="bankingForm"
        controlName="document"
        [label]="
          'features.settings.parameters.gateweeCollectionConfig.document.label'
            | translate
        "
        id="gcc-document"
        type="text"
      ></gatewee-input-v2>
    </div>
    <gatewee-input-v2
      [form]="formGroup"
      controlName="batchMinimumAmount"
      [label]="
        'features.settings.parameters.gateweeCollectionConfig.batchMinimumAmount.label'
          | translate
      "
      id="gcc-batchMinimumAmount"
      type="decimal"
    ></gatewee-input-v2>
    <div class="gw-flex gw-justify-end gw-gap-3 gw-mt-6">
      <gatewee-button
        variant="outline"
        [title]="'common.actions.cancel' | translate"
        (clicked)="close()"
        [disabled]="submitting"
      ></gatewee-button>
      <gatewee-button
        variant="primary"
        [title]="'common.actions.save' | translate"
        type="submit"
        [disabled]="submitting || formGroup.invalid"
      ></gatewee-button>
    </div>
  </form>
</div>
